import {
  IDeleteNotificationParams,
  IGetNotificationParams,
  INotification,
  INotificationSettings,
  INotificationSummary,
  IUpdateNotificationParams
} from '@aqx-core/common/api/notification';
import { request } from '@aqx-core/common/request';

export default {
  deleteNotification: (params: IDeleteNotificationParams) =>
    request.delete<boolean>('/api/notification/v1', { params }),
  getNotificationSettings: () => request.get<INotificationSettings[]>('/api/notification/v1/settings'),
  updateNotificationSettings: (params: IUpdateNotificationParams[]) =>
    request.post<boolean>('/api/notification/v1/settings', params),
  getUnreadNotificationCount: () => request.get<INotificationSummary[]>('/api/notification/v1/summary'),
  getNotifications: (params: IGetNotificationParams) => request.get<INotification[]>('/api/notification/v2', { params })
};
